const config = require("@/../config/config.json");

// loglevel = the higher the more logs appear
// use 0 for crucial messages
// use 5 for troubleshooting or dev env logging
export default function logger(message, loglevel = 0) {
	if (config.DEBUG && loglevel <= config.LOGLEVEL) console.log("-> ", message);
}
